
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
const $ = require("jquery");
$.Datatable = require("datatables.net");

const Transactionhistory = ({userMobile}) => {
  const [user, setUser] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(1); // ✅ Start page from 1
  const [numberOfPages, setNumberOfPages] = useState(0);

  const [searchList, setSearchList] = useState("");
  const [searchType, setSearchType] = useState("");
  const [findByStatus, setFindByStatus] = useState("");

  const backendLocal = process.env.REACT_APP_BACKEND_LOCAL_API;
  const backendLive = process.env.REACT_APP_BACKEND_LIVE_API;
  const baseUrl =
    process.env.NODE_ENV === "development" ? backendLocal : backendLive;

  const access_token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${access_token}`,
  };

  // ✅ Fetch data with current page and limit
  const fetchTransactions = async () => {
    try {
      const res = await axios.get(
        `${baseUrl}txn/deposit/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`,
        { headers }
      );

      // Optional filter for PAID data
      const pendingData = res?.data?.admin?.filter(
        (item) => item.status === "PAID"
      );
      setUser(pendingData || []);
      setNumberOfPages(res?.data?.totalPages || 0);
    } catch (e) {
      if (e.response?.status === 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
    }
  };

  // ✅ Handle page change
  const handlePageClick = (data) => {
    const currentPage = data.selected + 1; // react-paginate starts from 0
    setPageNumber(currentPage);
  };

  // ✅ When filters change, always go back to first page
  useEffect(() => {
    setPageNumber(1);
  }, [limit, searchList, searchType, findByStatus]);

  useEffect(() => {
    fetchTransactions();
  }, [pageNumber, limit, searchList, searchType, findByStatus]);

  const setpageLimit = (e) => setLimit(Number(e.target.value));

  const searchHandler = (e) => setSearchList(e.target.value);
  const searchByStatus = (e) => setFindByStatus(e.target.value);

  const dateFormat = (e) => {
    const date = new Date(e);
    return date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const newdateFormat = (e) => {
    const d = new Date(e);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };

  if (!user) return null;

  return (
    <div className="other_page_cards_main">
      <div className="row">
        <div className="col-12 grid-margin">
          <h4 className="other_page_cards_heading">Deposit History  </h4>

          {/* 🔍 Search Filters */}
          <div className="row">
            <select
              className="form-control col-sm-3 m-2"
              onChange={(e) => setSearchType(e.target.value)}
            >
              <option value="">Select Search by</option>
              <option value="Name">Name</option>
              <option value="Phone">Phone</option>
              <option value="_id">TxnId</option>
            </select>
            <input
              type="text"
              placeholder="Search..."
              className="form-control col-sm-4 m-2"
              onChange={searchHandler}
            />
            <h5>Or</h5>
            <select
              className="form-control col-sm-3 m-2"
              onChange={searchByStatus}
            >
              <option value="">Search Status</option>
              <option value="FAILED">FAILED</option>
              <option value="Pending">Pending</option>
              <option value="PAID">PAID</option>
            </select>
            <select
              className="form-control col-sm-1 m-1 bg-dark text-light"
              onChange={setpageLimit}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
          </div>

          {/* 🧾 Table */}
          <div className="table-responsive mt-3">
            <table className="table other_page_table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Phone</th>
                  <th>User</th>
                  <th>R_orderId</th>
                  <th>Amount</th>
                  <th>Image</th>
                  <th>Status</th>
                  <th>Action</th>
                  <th>Action By</th>
                  <th> Created Date</th>
                  <th>Update Date</th>
                </tr>
              </thead>
              <tbody>
                {user?.length > 0 ? (
                  user.map((data, key) => {
                    const id = data._id?.toString();
                    const timestamp = parseInt(id?.slice(0, 8), 16);
                    const gameCreatedAt = new Date(data.createdAt).getTime();
                    const currentTime = Date.now();

                    return (
                      <tr key={data._id}>
                        <td>{key + 1} | MSG-{timestamp}</td>
                        <td>{data._id}</td>
                        {/* <td>{data.User_id?.Phone || ""}</td> */}
                        <td>
  {userMobile
    ? data.User_id?.Phone || ""
    : data.User_id?.Phone
    ? `${data.User_id?.Phone.toString().slice(0, 2)}****${data.User_id?.Phone
        .toString()
        .slice(-2)}`
    : ""}
</td>
                        <td>
                          {data.User_id && (
                            <Link
                              className="btn btn-sm btn-outline-info"
                              to={`/user/view_user/${data.User_id._id}`}
                            >
                              {data.User_id.Name}
                            </Link>
                          )}
                        </td>
                        <td>
                          {data.order_token}
                          <p>
                            Type:{" "}
                            {data.client_ip || data?.payment_gatway || ""}
                          </p>
                        </td>
                        <td>{data.amount}</td>
                        <td>
                          <a
                            href={`${baseUrl}${data?.paymentImage}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              alt=""
                              src={`${baseUrl}${data?.paymentImage}`}
                              onError={(e) => {
                                e.target.src =
                                  "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg";
                              }}
                              height={80}
                            />
                          </a>
                        </td>
                        <td className="font-weight-bold text-success">
                          {data.status}
                        </td>
                        <td>
                          {data.status !== "PAID" &&
                          gameCreatedAt + 7200000 < currentTime ? (
                            <button
                              className="btn btn-danger"
                              onClick={() =>
                                alert("Deposit check logic here")
                              }
                            >
                              Check {data.payment_gatway}
                            </button>
                          ) : (
                            "Checked All"
                          )}
                        </td>
                        <td>{data?.action_by?.Name}</td>
                        <td>{dateFormat(data.createdAt).split(",")[0]}</td>
                        <td>{dateFormat(data.updatedAt).split(",")[0]}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center text-muted">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 🔢 Pagination */}
          <div className="mt-4">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={numberOfPages}
              forcePage={pageNumber - 1} // ✅ Sync pagination highlight
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transactionhistory;

